<template>
    <div class="row">
        <div class="col-xl-6 offset-xl-3">
            <h3 class="">Setup your classes.</h3>
            <el-table v-if="showTable" :data="model.classes">
                <el-table-column
                    min-width="70"
                    sortable
                    label="Number"
                    property="id"
                ></el-table-column>
                <el-table-column
                    min-width="150"
                    label="Name of class"
                    property="name"
                >
                    <div slot-scope="{ row,$index}">
                        <label :for="'name' + $index">Name of class</label>
                        <base-input
                            :id="'name' + $index" :name="'name' + $index"
                            v-model="model.classes[$index].name"
                            v-validate="modelValidations.name"
                            data-vv-as="name of class"
                            required
                            :error="getError('name' + $index)"
                            addon-left-icon="tim-icons icon-single-02"
                        >
                        </base-input>
                    </div>
                </el-table-column>
                <el-table-column
                    min-width="150"
                    label="Language"
                    property="language"
                >
                    <div slot-scope="{ row,$index}">
                        <label :for="'language' + $index">Language of class</label>
                        <base-input
                            :id="'language' + $index" :name="'language' + $index"
                            addon-left-icon="tim-icons icon-single-02">
                            <select v-model="model.classes[$index].language"
                                    class="form-control" id="exampleFormControlSelect1">
                                <option value="EN">English</option>
                                <option value="YI">Yiddish</option>
                            </select>
                        </base-input>
                    </div>
                </el-table-column>
                <el-table-column
                    min-width="150"
                    align="right"
                    header-align="right"
                    label="Amount of students"
                    property="amountStudents"
                >
                    <div slot-scope="{ row,$index}"
                         class="text-right table-actions">
                        <label :for="'studentsAmount' + $index">Amount of students</label>
                        <base-input type="number" :id="'studentsAmount' + $index" :name="'studentsAmount' + $index"
                                    v-model="model.classes[$index].amountStudents"
                                    required
                                    v-validate="modelValidations.amountStudents"
                                    data-vv-as="amount of students"
                                    :error="getError('studentsAmount')"/>
                    </div>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>

    export default {
        props: ['amountClasses'],
        data() {
            return {
                model: {
                    classes: [],
                },
                showTable: false,
                modelValidations: {
                    studentsAmount: {
                        required: true,
                        numeric: true,
                        min_value: 1,
                        max__value: 500,
                    },
                    name: {
                        required: true,
                        alpha_dash: true,
                        min: 1,
                        max: 50,
                    },
                },
            };
        },
        mounted() {
            this.initializeClasses();
        },
        methods: {
            initializeClasses() {
                console.log('Creating students UI');
                this.model.classes = [];
                for (let i = 0; i < this.amountClasses; i++) {
                    this.model.classes[i] = {
                        amountStudents: 1,
                        id: i + 1,
                        name: 'Class_' + (i + 1),
                        language: 'EN',
                    }
                }
                this.showTable = true;
            },
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                return this.$validator.validateAll().then(res => {
                    this.$emit('on-validated', res, this.model);
                    return res;
                });
            }
        },
        watch: {
            amountClasses: function (newAmount, oldAmount) {
                this.initializeClasses();
            }
        }
    };
</script>
<style></style>
